import { render, staticRenderFns } from "./headTip.vue?vue&type=template&id=7646a5e5&scoped=true"
import script from "./headTip.vue?vue&type=script&lang=js"
export * from "./headTip.vue?vue&type=script&lang=js"
import style0 from "./headTip.vue?vue&type=style&index=0&id=7646a5e5&prod&lang=css"
import style1 from "./headTip.vue?vue&type=style&index=1&id=7646a5e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7646a5e5",
  null
  
)

export default component.exports